import type { BlockyJson } from "./core/blockly-types.ts";

export type BlocklySearchEntryJson = BlockyJson;

export interface BlocklySearchEntry {
  type: string;
  json: BlocklySearchEntryJson;
  custom?: string;
  tooltip?: string;
}

export type BlocklySearchSink = (entry: BlocklySearchEntry) => void;

const noopBlocklySearchSink: BlocklySearchSink = () => undefined;
let currentBlocklySearchSink: BlocklySearchSink = noopBlocklySearchSink;

export function setBlocklySearchSink(sink: BlocklySearchSink | null | undefined): void {
  currentBlocklySearchSink = sink ?? noopBlocklySearchSink;
}

export function getBlocklySearchSink(): BlocklySearchSink {
  return currentBlocklySearchSink;
}
